// Time between polling for new alerts (15 minutes)
const ALERT_POLLING_INTERVAL = 900000

export {
  ALERT_POLLING_INTERVAL
}
